import axios from 'axios';
import { useAuth } from '../Contexts/AuthContext';

const usePost = (url) => {
    const { currentUser } = useAuth() || {};
    const { accessToken } = { ...currentUser };
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const post = (body, method, id) => {
        const options = {
            url: id !== undefined ? `${baseURL}${url}${`/${id}`}` : `${baseURL}${url}`,
            method,
            data: body,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${accessToken}`,
            },
        };

        return axios(options);
    };

    return {
        post,
    };
};

export default usePost;
